import {DashboardLayout, PrimaryButton} from 'components';
import React, {useState} from 'react';
import {connect} from 'react-redux';
import {toast} from 'react-toastify';
import GetPlanModal from './GetPlanModal';

const pricingSections = [
  {
    title: 'Core Usage',
    rows: [
      {
        name: 'Total Events',
        basic: '200,000',
        premium: '1,000,000',
        enterprise: 'Unlimited',
      },
      {
        name: 'Total Profiles',
        basic: '10,000',
        premium: '50,000',
        enterprise: 'Unlimited',
      },
    ],
  },
  {
    title: 'Feature',
    rows: [
      {
        name: 'Rule Creation',
        basic: 'check',
        premium: 'check',
        enterprise: 'check',
      },
      {
        name: 'Flow Creation',
        basic: '2 Flows',
        premium: '5 Flows',
        enterprise: 'Unlimited',
      },
      {
        name: 'Custom List',
        basic: '5',
        premium: 'Up to 10',
        enterprise: 'Unlimited',
      },
      {
        name: 'Behavioural Analysis',
        basic: 'check',
        premium: 'check',
        enterprise: 'check',
      },
      {
        name: 'Data Retention period',
        basic: '90 days',
        premium: '1 year',
        enterprise: '2 years',
      },
      {
        name: 'Reporting & Analytics',
        basic: '-',
        premium: 'check',
        enterprise: 'check',
      },
      {
        name: 'SAR Generation',
        basic: '-',
        premium: 'check',
        enterprise: 'check',
      },
      {
        name: 'AI Case Review',
        basic: '-',
        premium: 'check',
        enterprise: 'check',
      },
      {
        name: 'AI Rule Generation',
        basic: 'Coming Soon',
        premium: 'Coming Soon',
        enterprise: 'Coming Soon',
      },
    ],
  },
  {
    title: 'Integrations',
    rows: [
      {
        name: 'Webhook Endpoint',
        basic: 'check',
        premium: 'check',
        enterprise: 'check',
      },
    ],
  },
  {
    title: 'Support',
    rows: [
      {
        name: 'Email support',
        basic: 'check',
        premium: 'check',
        enterprise: 'check',
      },
      {
        name: 'Dedicated Support',
        basic: '-',
        premium: 'check',
        enterprise: 'check',
      },
      {
        name: 'User Access',
        basic: 'Up to 2',
        premium: 'Up to 10',
        enterprise: 'Unlimited',
      },
      {
        name: 'Custom Features',
        basic: '-',
        premium: '-',
        enterprise: 'check',
      },
    ],
  },
];

const planDetails = {
  Basic: {
    name: 'Basic',
    priceString: '$500',
    quota: '200,000/month',
    subtotal: '₦300,000',
    vat: '₦30,000',
    total: '₦330,000',
  },
  Premium: {
    name: 'Premium',
    priceString: '$1,500',
    quota: '1,000,000/month',
    subtotal: '₦900,000',
    vat: '₦90,000',
    total: '₦990,000',
  },
};

function ProfiledRiskUpgrade(props) {
  const {
    auth: {userDetails},
  } = props;
  const baseColor = userDetails?.company?.color_code || '#3f7cdb';
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const [openSections, setOpenSections] = useState({
    'Core Usage': true,
    Feature: true,
    Integrations: true,
    Support: true,
  });

  const toggleSection = title => {
    setOpenSections(prev => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  const handleGetStartedClick = planName => {
    if (planName === 'Enterprise') {
      toast.success('Please contact support for Enterprise plan details.');
    } else {
      setSelectedPlan(planDetails[planName]);
      setModalOpen(true);
    }
  };

  const CheckIcon = () => (
    <div
      style={{backgroundColor: baseColor}}
      className="w-5 h-5 rounded-full flex items-center justify-center mx-auto"
    >
      <svg
        className="w-3 h-3 text-white"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={3}
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
  );

  const renderFeatureValue = value => {
    if (value === 'check') {
      return <CheckIcon />;
    }
    if (value === '-') {
      return <span className="text-[#71717A] text-lg">-</span>;
    }
    return <span className="text-[#71717A]">{value}</span>;
  };

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Billing</p>
      }
    >
      <div className="py-6">
        <div className="mb-6">
          <h2 className="text-lg font-medium text-[#080917] mb-1">
            Select Plan
          </h2>
          <p className="text-small text-black">
            Plans are designed to meet your need
          </p>
        </div>

        <div className="overflow-x-auto">
          <div className="grid grid-cols-4 min-w-[924px]">
            <div className="p-4 mb-2 bg-white flex flex-col justify-center">
              <h3 className="text-lg font-medium text-[#252430]">
                Features by plan
              </h3>
              <p className="text-small text-[#858BA0] mt-1 font-medium">
                Pricing plans are designed to meet your need
              </p>
            </div>

            <div className="p-4 mb-2 flex flex-col items-start justify-between bg-white border border-[#E4E4E7] rounded-lg">
              <h3 className="text-[18px] font-semibold text-black pl-2">
                Basic
              </h3>
              <p className="text-[29px] font-bold mt-4 mb-6 pl-2 text-[#18181B]">
                $500
                <span className="text-small font-normal text-[#18181B]">
                  /month
                </span>
              </p>
              <PrimaryButton
                buttonText="Get started"
                onClick={() => handleGetStartedClick('Basic')}
                className="!w-full !rounded-[4px] !py-[11px]"
              />
            </div>

            <div className="p-4 mb-2 flex mx-3.5 flex-col items-start justify-between bg-white border border-[#E4E4E7] rounded-lg">
              <h3 className="text-[18px] font-semibold text-black pl-2">
                Premium
              </h3>
              <p className="text-[29px] font-bold mt-4 mb-6 pl-2 text-[#18181B]">
                $1,500
                <span className="text-small font-normal text-[#18181B]">
                  /month
                </span>
              </p>
              <PrimaryButton
                buttonText="Get started"
                className="!w-full !rounded-[4px] !py-[11px]"
                onClick={() => handleGetStartedClick('Premium')}
              />
            </div>

            <div className="p-4 flex flex-col mb-2 items-start justify-between bg-white border border-[#E4E4E7] rounded-lg">
              <h3 className="text-[18px] font-semibold text-black pl-2">
                Enterprise
              </h3>
              <p className="text-[29px] font-bold mt-4 mb-6 pl-2 text-[#18181B]">
                Custom
              </p>
              <PrimaryButton
                buttonText="Get started"
                className="!w-full !rounded-[4px] !py-[11px] !border"
                style={{
                  background: 'transparent',
                  color: baseColor,
                  border: `1px solid ${baseColor}`,
                }}
                onClick={() => handleGetStartedClick('Enterprise')}
              />
            </div>

            {pricingSections.map(section => {
              const isOpen = openSections[section.title];
              return (
                <React.Fragment key={section.title}>
                  <div
                    onClick={() => toggleSection(section.title)}
                    className="col-span-4 p-3 bg-[#F7F7F7] px-3 py-3.5 cursor-pointer hover:bg-gray-100 transition-colors flex justify-between items-center"
                  >
                    <h4 className="text-tiny font-medium text-[#18181B]">
                      {section.title}
                    </h4>
                    <svg
                      className={`w-4 h-4 text-gray-500 transform transition-transform duration-200 ${
                        isOpen ? 'rotate-180' : 'rotate-0'
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>

                  {isOpen &&
                    section.rows.map((row, rIdx) => (
                      <React.Fragment key={`${section.title}-${rIdx}`}>
                        <div className="p-4 text-tiny font-medium text-[#18181B] flex items-center border-b border-[#D4D4D8]">
                          {row.name}
                        </div>
                        <div className="p-4 text-center text-tiny font-medium text-[#71717A] border-b border-[#D4D4D8] flex items-center justify-center">
                          {renderFeatureValue(row.basic)}
                        </div>
                        <div className="p-4 text-center text-tiny font-medium text-[#71717A] border-b border-[#D4D4D8] flex items-center justify-center">
                          {renderFeatureValue(row.premium)}
                        </div>
                        <div className="p-4 text-center text-tiny font-medium text-[#71717A] border-b border-[#D4D4D8] flex items-center justify-center">
                          {renderFeatureValue(row.enterprise)}
                        </div>
                      </React.Fragment>
                    ))}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>

      {selectedPlan && (
        <GetPlanModal
          open={modalOpen}
          setOpen={() => setModalOpen(false)}
          plan={selectedPlan}
          baseColor={baseColor}
        />
      )}
    </DashboardLayout>
  );
}

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(ProfiledRiskUpgrade);
